import React from 'react';
import styles from '../../styles/ReportesFinancierosStyles/ReportesFinancieros.module.css';

function ReportSummary({ resumenBecas = {}, totalBecas = 0 }) {
  const entries = Object.entries(resumenBecas);

  if (entries.length === 0) return null;

  return (
    <div className={styles.summarySection}>
      <h3 className={styles.summaryTitle}>Valor Anual</h3>
      <p className={styles.summarySubtitle}>Número de destinatarios por tipo de Beca</p>
      <table className={styles.summaryTable}>
        <thead>
          <tr>
            <th>Tipo de Beca</th>
            <th>Destinatarios</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(([beca, count]) => (
            <tr key={beca}>
              <td>{beca}</td>
              <td>{count}</td>
            </tr>
          ))}
          <tr className={styles.summaryTotal}>
            <td>Total</td>
            <td>{totalBecas}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default ReportSummary;
